const { createRecipeTiles } = require('../shop/tiles/recipe-tile-factory');

class RecipeTileListController {
    constructor(settings, recipeService, sortByKeys) {
        this.settings = settings;
        this.recipeService = recipeService;
        this.sortByKeys = sortByKeys;
    }

    $onInit() {
        this.sortOptions = { sortTypes: this.settings.recipe.sortOptions, sortContext: this.sortByKeys.RECIPE_KEY };
    }

    createTiles(tiles) {
        return {
            items: createRecipeTiles(tiles.items),
            totalRecordCount: tiles.totalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber, sortType) {
        return this.recipeService.getRecipes(this.currentCategory.aisle.ID, pageSize, pageNumber, sortType)
            .then(tiles => this.createTiles(tiles));
    }
}

RecipeTileListController.$inject = ['Settings', 'RecipeService', 'SortByKeys'];

const recipeTileListComponentDefinition = {
    bindings: {
        currentCategory: '<',
        pageNumber: '<',
        sortBy: '<',
    },
    controller: RecipeTileListController,
    template: `
        <wow-tile-list
            list-title="::$ctrl.currentCategory.aisle.Name"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">
        </wow-tile-list>
    `,
};

module.exports = {
    RecipeTileListController,
    recipeTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipe-tile-list.component.js